// actions/loaderActions.js
export const showLoader = () => ({ type: 'SHOW_LOADER' });
export const hideLoader = () => ({ type: 'HIDE_LOADER' });

// reducers/loaderReducer.js
const initialState = { isLoading: false };

const loaderReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SHOW_LOADER':
      return { isLoading: true };
    case 'HIDE_LOADER':
      return { isLoading: false };
    default:
      return state;
  }
};

export default loaderReducer;
